import React, { Component } from 'react';
import Iterator from '../core/Iterator';
import ParameterErrors from '../errors/ParameterErrors';
import ParameterValidation from '../validation/ParameterValidation';
import Scene360LayerChoice from './Scene360LayerChoice';
const{throwNotProvided}=ParameterErrors;
export default class Scene360Layer {
	constructor(props){
		const {choices, slug} = props;
		ParameterValidation.validateArray(choices, 'choices', Scene360LayerChoice);
		this._choices = choices;
		
		if(slug ===undefined||slug===null)
			throwNotProvided('slug');
		this._slug = slug;
	}
	get choices(){
		return this._choices;
	}
	get slug(){
		return this._slug;
	}
}
